import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-211">
      <div className="max-w-4xl mx-auto" data-id="element-212">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_20px_50px_-20px_rgba(139,111,191,0.25)] rounded-3xl p-8 sm:p-14 text-center relative overflow-hidden" data-id="element-213">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-primary/5 blur-[60px] pointer-events-none" data-id="element-214"></div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-cta-green/10 text-cta-green border border-cta-green/25 px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold uppercase tracking-wider mb-6 relative z-10" data-id="element-215">
            <ShieldCheck className="w-4 h-4" data-id="element-216" />
            Garantía total 7 días
          </div>

          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight relative z-10" data-id="element-217">
            Si no es para ti, te devolvemos el{' '}
            <span className="text-cta-green" data-id="element-218">100%</span>.
          </h2>

          <p className="text-text-sec text-base sm:text-lg leading-relaxed font-medium max-w-2xl mx-auto relative z-10 mb-6" data-id="element-219">
            Abres los 6 tomos. Revisas los 6 bonos. Los usas en tu próxima clase
            si quieres. Si en{' '}
            <span className="text-text-main font-bold" data-id="element-220">7 días</span> no es lo
            que esperabas, te devolvemos cada centavo.
          </p>

          {/* Triple proof */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 max-w-2xl mx-auto mb-6 relative z-10" data-id="element-221">
            <div className="bg-bg-main/60 border border-border-light rounded-xl px-4 py-3" data-id="element-222">
              <p className="text-text-main font-black text-sm" data-id="element-223">Sin preguntas</p>
              <p className="text-text-sec text-xs mt-0.5" data-id="element-224">
                No te pedimos explicaciones
              </p>
            </div>
            <div className="bg-bg-main/60 border border-border-light rounded-xl px-4 py-3" data-id="element-225">
              <p className="text-text-main font-black text-sm" data-id="element-226">
                Sin formularios
              </p>
              <p className="text-text-sec text-xs mt-0.5" data-id="element-227">
                Solo un email y listo
              </p>
            </div>
            <div className="bg-bg-main/60 border border-border-light rounded-xl px-4 py-3" data-id="element-228">
              <p className="text-text-main font-black text-sm" data-id="element-229">Sin drama</p>
              <p className="text-text-sec text-xs mt-0.5" data-id="element-230">Devolución en 48hs</p>
            </div>
          </div>

          <p className="text-text-sec text-xs sm:text-sm font-medium relative z-10" data-id="element-231">
            Más de{' '}
            <span className="text-text-main font-bold" data-id="element-232">
              15.000 instructoras
            </span>{' '}
            ya lo usan. Nuestra tasa de devolución es menor al 1%.
          </p>
        </div>
      </div>
    </section>;
}